import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { TypeSubtableModel } from '../models/typeSubtable.model';

export const typeSubtableAdapter: AdapterFunc<GQL.TypeOutputDto, TypeSubtableModel> = (input) => ({
  id: input.id,
  name: input.name!,
  isDeletable: input.boolean!,
});
